export default {
  SITE: 'SITE',
  EMAILS: 'EMAILS',
}
